export const urls = {
  GET_JEZIK: 'Combo/vrati_jezike_combo',
  GET_MAIN_CATEGORY: 'Combo/vrati_kategorije_dokumenata',
  GET_DOKUMENTA: 'Dokumenta/dokumenta_vrati_dokumenta_za_objekat',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  UPDATE_DOKUMENTA: 'Dokumenta/izmena_dokumentacije_objekta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
};
